<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'productName')">
              <a-select
                v-model='queryParam.appssidList'
                mode='multiple'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span='8'>
            <a-form-item :label="$t(I18N_KEY.APPROVAL + 'questionSubTime')" :labelCol='{span: 6}'
                         :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.questionSubDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :span='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'questionType')">
              <dict-select
                v-model='queryParam.messageType'
                :dict-code='DICT_CODE.messageBoardType_STATUS'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :span='6'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'appVersion')">
              <a-input v-model='queryParam.appVersion'>
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :span='12'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>

      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <Dict slot='messageTypeslot' slot-scope='text' :dict-code='DICT_CODE.messageBoardType_STATUS' :value='text' />
        <!--        <span slot='action' slot-scope='text, record'>-->
        <!--            <a @click='handleView(record)'>{{ $t('view') }}</a>-->
        <!--        </span>-->
        <template slot='messagebox' slot-scope='text,record'>
          <div style='width: 550px;height: 100px;overflow-y: scroll'>
            {{ text }}
          </div>
        </template>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryCustMessageBorad } from '@/webpublicapi/customer'
import { getApplist } from '@/webpublicapi/order'
import Dict from '../modules/Dict.vue'
import DictSelect from '../modules/DictSelect.vue'
import moment from 'moment'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}
export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect
  },
  data() {
    return {
      I18N_KEY,
      visible: false,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      messageType: undefined,
      // 查询条件
      queryParam: {
        'messageType': '',
        'appVersion': '',
        'questionSubDate': [moment().add('days'), moment().add('days', 0)],
        appssidList: []
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'ID',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'productName'),
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'appVersion'),
          align: 'left',
          dataIndex: 'appVersion'
        },
        {
          title: this.$t('name'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          width: 150,
          dataIndex: 'userMobile'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'questionType'),
          align: 'left',
          // dataIndex: 'messageTypeName',
          dataIndex: 'messageType',
          scopedSlots: { customRender: 'messageTypeslot' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'contentValue'),
          align: 'left',
          dataIndex: 'message',
          width: 550,
          scopedSlots: { customRender: 'messagebox' }
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'questionSubTime'),
          align: 'left',
          dataIndex: 'createdTime',
          // defaultSortOrder: 'descend',
          // sortDirections: ['descend', 'ascend'],
          // sorter:(a,b)=> this.sort(a,b),
        }
        // {
        //   title: this.$t('action'),
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 100,
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created() {
    this.loadData(1)
    getApplist().then(res => {
      this.appList = res.data || []
    })
  },
  methods: {
    handleView(val) {
      console.log('点击了查看', val)
    },
    searchQuery() {
      this.loadData(1)
    },
    sort(a,b){
      console.log('a',a)
      console.log('b',b)
      return  this.convertToTimestamp(a.createdTime) - this.convertToTimestamp(b.createdTime)
    },
    convertToTimestamp(dateString) {
      const dateObject = new Date(dateString);
      console.log('dateObject',dateObject.getTime())
      return dateObject.getTime();
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      queryCustMessageBorad(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data && res.data.total
          this.total = res.data.total
          this.dataSource = res.data.rows || []
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { questionSubDate } = this.queryParam
      const data = {
        ...this.queryParam,
        dateStart: questionSubDate && this.transformTime(questionSubDate[0]),
        dateEnd: questionSubDate && this.transformTime(questionSubDate[1]),
        pageSize: '10'
      }
      delete data.questionSubDate
      data.pageNum = this.form.pageNum
      data.pageSize = this.form.pageSize
      return filterObj(data)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.questionSubDate = [moment().add('days'), moment().add('days', 0)]
      that.queryParam.appssidList = []
      that.queryParam.appVersion = ''
      that.queryParam.messageType = ''
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

::-webkit-scrollbar {
  width: 5px; /* 设置滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  background-color: #1890FF; /* 设置滚动条颜色 */
}
</style>
